import { useQuery } from '@tanstack/react-query';
import { api } from '../../libs/axios';
import { ContaCorrente, Viacao } from '../../utils/interfaces';

export interface FaturaFilter {
  status?: string;
  empresa?: string;
  usuario?: string;
  data_inicial?: string;
  data_final?: string;
}

interface ResponseProps {
  conta: ContaCorrente;
  agencia: Viacao;
}

async function getContaCorrente(): Promise<ResponseProps> {
  const response = await api
    .get('conta')
    .then((res) => res.data);

  return {
    agencia: response.agencia,
    conta: response.conta,
  };
}

export function useContaCorrente() {
  return useQuery({
    queryKey: ['conta-corrente'],
    queryFn: () => getContaCorrente(),
    staleTime: 1,
    gcTime: 1,
    retry: false,
    refetchOnWindowFocus: false,
  });
}